import { moduleStyleType } from 'components/no-ui/styles/styleTypes'
import { getAvatarSizeStyles, getAvatarIconSize, AvatarSize } from './AvatarSizes'

// Unified Avatar Styles - the single source of truth for all avatar styling
export const avatarStyles: moduleStyleType = {
    // Base avatar styles
    avatar: {
        ...getAvatarSizeStyles('md'),
        fontWeight: 500,
        color: 'primary.main',
        backgroundColor: 'primary.light',
        textTransform: 'uppercase',
        display: 'inline-flex',
        verticalAlign: 'middle',
        borderRadius: '50%',
    },

    // Size variants
    xs: getAvatarSizeStyles('xs'),
    sm: getAvatarSizeStyles('sm'),
    md: getAvatarSizeStyles('md'),
    lg: getAvatarSizeStyles('lg'),
    xl: getAvatarSizeStyles('xl'),

    // Behavioral styles
    mouseHover: {
        '&:hover': {
            cursor: 'pointer',
        },
    },

    // Specialized avatar styles
    agentAvatar: {
        backgroundColor: 'brand.green',
    },

    // App user avatar styles
    appUserAvatar: {
        border: '1px solid',
        borderColor: 'border.primary',
        color: 'text.primary',
        backgroundColor: 'background.default',
        textTransform: 'uppercase',
    },

    // App avatar styles
    appAvatar: {
        backgroundColor: 'background.default',
        display: 'inline-flex',
        verticalAlign: 'middle',
        border: '1px solid',
        borderColor: 'border.primary',
        borderRadius: 1,
    },

    // Resource type avatar styles
    resourceTypeAvatar: {
        border: '1px solid',
        borderColor: 'border.primary',
        backgroundColor: 'background.default',
        borderRadius: 1,
        display: 'inline-flex',
        verticalAlign: 'middle',
    },
}

// No-user avatar styles (for empty states)
export const noUserAvatarStyles: moduleStyleType = {
    sm: {
        transform: 'scale(0.6)',
    },
    md: {
        transform: 'scale(0.7)',
    },
    lg: {
        transform: 'scale(1.2)',
    },
    noUserColor: {
        color: 'primary.main',
    },
}

// Icon styles for different avatar sizes - generated from getAvatarIconSize function
const generateIconStyles = (): moduleStyleType => {
    const sizes: AvatarSize[] = ['xs', 'sm', 'md', 'lg', 'xl']
    const styles: moduleStyleType = {
        icon: {
            maxHeight: `${getAvatarIconSize('md')}px`,
            maxWidth: `${getAvatarIconSize('md')}px`,
        },
        default: {
            color: 'text.primary',
        },
    }

    sizes.forEach((size) => {
        const iconSize = getAvatarIconSize(size)
        styles[`${size}Icon`] = {
            maxHeight: `${iconSize}px`,
            maxWidth: `${iconSize}px`,
        }
    })

    return styles
}

export const avatarIconStyles: moduleStyleType = generateIconStyles()
